import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import HomeBloc from "../../../../bloc/home_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import Config from "../../../../Config";

import FormBloc from "../../../../bloc/forms_bloc";
import AppSelectButton from "../../../component/app_select_button/app_select_button";
import AppSelectField from "../../../component/app_select_field/app_select_field";
import AppTextField from "../../../component/app_text_field/app_text_field";
import "./proposal_form.css";
import UtilBloc from "../../../../bloc/util_bloc";
class ResidentialForeignTravelQuestionaire extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            countryList: [],
            stateList: [],
            cityList: [],
            postcodeList: [],
            stayCityList: [],
            stayPostcodeList: [],

            //form start
            residentialData: {
                stayDuration: null,
                residenceOrTravelAddress: null,
                residenceOrTravelCountry: null,
                residenceOrTravelState: null,
                residenceOrTravelPostcode: null,
                residenceOrTravelCity: null,
                travelStayDuration: null,
                isFirstEMploymentReason: null,
                isStayThroughout: null,
                typeOfStay: null,
                acommodationLocated: null,
                liveWorkCondition: null,
                politicalSituation: null,

                notFisrtEmployment: null,
                notStayThroughoutAddress: null,
                notStayThroughoutCountry: null,
                notStayThroughoutState: null,
                notStayThroughoutPostcode: null,
                notStayThroughoutCity: null,
                otherAccommodationType: null,
            },

            //form end
            errorMessage: 'Fill in the required field.',
            isUpdate: false,
        };
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.initiateData();
    }

    initiateData() {
        let formData = this.props.value;
        let stateData = this.state.residentialData;
        FormBloc.getCountryList().then((res) => {
            this.setState({ countryList: res.data });
        })
        FormBloc.getStateList().then((res) => {
            this.setState({ stateList: res.data });
        })
        formData && Object.keys(formData).map(function (key) {
            stateData[key] = formData[key];
        })
        this.setState({ residentialData: stateData })
    }

    getFormFields() {
        return this.props.fields;
    }

    //handle change start
    handleValueChange = (field, val) => {
        let data = this.state.residentialData;
        data[field] = val
        if (field === "residenceOrTravelState") {
            FormBloc.getCityList(val).then((res) => {
                this.setState({ cityList: res.data });
            })
        } else if (field === "residenceOrTravelCity") {
            if (data.residenceOrTravelState) {
                FormBloc.getPostcodeList(data.residenceOrTravelState, val).then((res) => {
                    this.setState({ postcodeList: res.data });
                })
            }
        }
        if (field === "notStayThroughoutState") {
            FormBloc.getCityList(val).then((res) => {
                this.setState({ stayCityList: res.data });
            })
        } else if (field === "notStayThroughoutCity") {
            if (data.notStayThroughoutState) {
                FormBloc.getPostcodeList(data.notStayThroughoutState, val).then((res) => {
                    this.setState({ stayPostcodeList: res.data });
                })
            }
        }
        this.setState({ residentialData: data }, this.onValidateForm());

    }

    // handleExtraValueChange = (field, val) => {
    //     this.setState({ [field]: val }, () => {
    //         this.onValidateForm();
    //     });

    // }

    onValidateForm = () => {
        const { residentialData } = this.state;
        let validated = UtilBloc.residentialDetailsDataValidation(residentialData);
        this.setPropValidation(validated);
        this.setPropValue();
    }

    setPropValue = () => {
        const { residentialData } = this.state;

        this.props.onChange(residentialData);
    }

    setPropValidation = (result) => {
        this.props.handleValidationResult(result);
    }

    async handleFormSubmit() {

    }

    showerror = (val) => {
        return val !== null && UtilBloc.isNullOrEmpty(val)
    }
    showExtraFormError = (parent, val, ind) => {
        if (parent === ind) {
            return val !== null && UtilBloc.isNullOrEmpty(val)
        }
        else
            return false
    }

    // form element start
    stayDuration() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.residentailForeignTravelFormTitle.stayDuration}
                type={'text'}
                placeholder={'00 months'}
                value={this.state.residentialData.stayDuration}
                onChange={(e) => {
                    if (e) {
                        let value = e;
                        if (/^\d*\.?\d*$/.test(value)) {
                            this.handleValueChange(this.getFormFields().stayDuration, value);
                        }
                    } else {
                        this.handleValueChange(this.getFormFields().stayDuration, e);
                    }
                }}
                error={this.showerror(this.state.residentialData.stayDuration)}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    residenceOrTravelAddress() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.residentailForeignTravelFormTitle.residenceOrTravelAddress}
                type={'text'}
                placeholder={'Enter floor / unit / street name...'}
                value={this.state.residentialData.residenceOrTravelAddress}
                onChange={(e) => this.handleValueChange(this.getFormFields().residenceOrTravelAddress, e)}
                error={this.showerror(this.state.residentialData.residenceOrTravelAddress)}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    residenceOrTravelCountry() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.residentailForeignTravelFormTitle.residenceOrTravelCountry}
                value={this.state.residentialData.residenceOrTravelCountry}
                showSearch={true}
                placeholder="Select country..."
                options={this.state.countryList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => e !== "MYS" ?
                    this.setState((prevState) => ({
                        residentialData: {
                            ...prevState.residentialData,  // Maintain existing state
                            residenceOrTravelState: null, residenceOrTravelPostcode: null, residenceOrTravelCity: null,
                        }
                    }), () => { this.handleValueChange(this.getFormFields().residenceOrTravelCountry, e) })
                    : this.handleValueChange(this.getFormFields().residenceOrTravelCountry, e)}
                error={this.showerror(this.state.residentialData.residenceOrTravelCountry)}
                errorMessage={this.state.errorMessage}
            />

        )
    }
    residenceOrTravelState() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyState}
                value={this.state.residentialData.residenceOrTravelState}
                placeholder={'Select state...'}
                options={this.state.stateList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().residenceOrTravelState, e)}
            />
        )
    }
    residenceOrTravelPostcode() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyPostcode}
                value={this.state.residentialData.residenceOrTravelPostcode}
                placeholder={'Enter postcode...'}
                options={this.state.postcodeList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().residenceOrTravelPostcode, e)}
            />
        )
    }
    residenceOrTravelCity() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyCity}
                value={this.state.residentialData.residenceOrTravelCity}
                placeholder={'Enter city...'}
                options={this.state.cityList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().residenceOrTravelCity, e)}
            />
        )
    }
    travelStayDuration() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.residentailForeignTravelFormTitle.travelStayDuration}
                type={'text'}
                placeholder={'00 months'}
                value={this.state.residentialData.travelStayDuration}
                onChange={(e) => {
                    if (e) {
                        let value = e;
                        if (/^\d*\.?\d*$/.test(value)) {
                            this.handleValueChange(this.getFormFields().travelStayDuration, value);
                        }
                    } else {
                        this.handleValueChange(this.getFormFields().travelStayDuration, e);
                    }
                }} 
                error={this.showerror(this.state.residentialData.travelStayDuration)}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    isFirstEMploymentReason() {
        return (
            <div style={{ fontSize: 14 }}>
                {Config.proposal.formDataMapping.step1.residentailForeignTravelFormTitle.isFirstEMploymentReason}
                <div className="row m-0 w-100 mt-2">
                    <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                        <AppSelectButton
                            // title={Config.proposal.formDataMapping.step1.residentailForeignTravelFormTitle.isConsultOrTreatment}
                            value={this.state.residentialData.isFirstEMploymentReason}
                            handleNegativePress={() => this.handleValueChange(this.getFormFields().isFirstEMploymentReason, 'No')}
                            handlePositivePress={() =>
                                this.setState((prevState) => ({
                                    residentialData: {
                                        ...prevState.residentialData, notFisrtEmployment: null
                                    }
                                }), () => { this.handleValueChange(this.getFormFields().isFirstEMploymentReason, 'Yes') })}
                        />
                    </div>
                </div>
            </div>
        )
    }
    notFisrtEmployment() {
        return (
            <AppTextField
                type={'text'}
                multiline={true}
                showCount
                maxLength={1000}
                placeholder={'Please provide details...'}
                value={this.state.residentialData.notFisrtEmployment}
                onChange={(e) => this.handleValueChange("notFisrtEmployment", e)}
                error={this.showExtraFormError(this.state.residentialData.isFirstEMploymentReason, this.state.residentialData.notFisrtEmployment, "No")}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    isStayThroughout() {
        return (
            <div style={{ fontSize: 14 }}>
                {Config.proposal.formDataMapping.step1.residentailForeignTravelFormTitle.isStayThroughout}
                <div className="row m-0 w-100 mt-2">
                    <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                        <AppSelectButton
                            // title={Config.proposal.formDataMapping.step1.residentailForeignTravelFormTitle.isConsultOrTreatment}
                            value={this.state.residentialData.isStayThroughout}
                            handleNegativePress={() => this.handleValueChange(this.getFormFields().isStayThroughout, 'No')}
                            handlePositivePress={() => this.setState((prevState) => ({
                                residentialData: {
                                    ...prevState.residentialData, notStayThroughoutAddress: null, notStayThroughoutCountry: null, notStayThroughoutState: null, notStayThroughoutPostcode: null, notStayThroughoutCity: null
                                }
                            }), () => { this.handleValueChange(this.getFormFields().isStayThroughout, 'Yes') })}
                        />
                    </div>
                </div>
            </div>
        )
    }
    notStayThroughoutAddress() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.residentailForeignTravelFormTitle.notStayThroughoutAddress}
                type={'text'}
                placeholder={'Enter floor / unit / street name...'}
                value={this.state.residentialData.notStayThroughoutAddress}
                onChange={(e) => this.handleValueChange("notStayThroughoutAddress", e)}
                error={this.showExtraFormError(this.state.residentialData.isStayThroughout, this.state.residentialData.notStayThroughoutAddress, "No")}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    notStayThroughoutCountry() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.country}
                value={this.state.residentialData.notStayThroughoutCountry}
                showSearch={true}
                placeholder="Select country..."
                options={this.state.countryList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => e !== "MYS" ?
                    this.setState((prevState) => ({
                        residentialData: {
                            ...prevState.residentialData,  // Maintain existing state
                            notStayThroughoutState: null, notStayThroughoutPostcode: null, notStayThroughoutCity: null,
                        }
                    }), () => { this.handleValueChange("notStayThroughoutCountry", e) })
                    : this.handleValueChange("notStayThroughoutCountry", e)}
            />
        )
    }
    notStayThroughoutState() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyState}
                value={this.state.residentialData.notStayThroughoutState}
                placeholder={'Select state...'}
                options={this.state.stateList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange("notStayThroughoutState", e)}
            />
        )
    }
    notStayThroughoutPostcode() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyPostcode}
                value={this.state.residentialData.notStayThroughoutPostcode}
                placeholder={'Enter postcode...'}
                options={this.state.stayPostcodeList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange("notStayThroughoutPostcode", e)}
            />
        )
    }
    notStayThroughoutCity() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyCity}
                value={this.state.residentialData.notStayThroughoutCity}
                placeholder={'Enter city...'}
                options={this.state.stayCityList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange("notStayThroughoutCity", e)}
            />
        )
    }
    typeOfStay() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.residentailForeignTravelFormTitle.typeOfStay}
                value={this.state.residentialData.typeOfStay}
                placeholder={'Select type of accommodation...'}
                options={Config.quotation.optionItem.accommodationType}
                onChange={(e) => e !== "Other accommodation?" ?
                    this.setState((prevState) => ({
                        residentialData: {
                            ...prevState.residentialData, otherAccommodationType: null
                        }
                    }), () => { this.handleValueChange(this.getFormFields().typeOfStay, e) })
                    : this.handleValueChange(this.getFormFields().typeOfStay, e)}
            />
        )
    }

    acommodationLocated() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.residentailForeignTravelFormTitle.acommodationLocated}
                type={'text'}
                placeholder={'Enter location of your accommodation...'}
                value={this.state.residentialData.acommodationLocated}
                onChange={(e) => this.handleValueChange(this.getFormFields().acommodationLocated, e)}
                error={this.showerror(this.state.residentialData.acommodationLocated)}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    otherAccommodationType() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.residentailForeignTravelFormTitle.otherAccommodationType}
                type={'text'}
                placeholder={'Please enter acommodation type...'}
                value={this.state.residentialData.otherAccommodationType}
                onChange={(e) => (this.handleValueChange("otherAccommodationType", e))}
                error={this.showExtraFormError(this.state.residentialData.typeOfStay, this.state.residentialData.otherAccommodationType, "Other accommodation?")}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    liveWorkCondition() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.residentailForeignTravelFormTitle.liveWorkCondition}
                value={this.state.residentialData.liveWorkCondition}
                placeholder={'Select living and working condition...'}
                options={Config.quotation.optionItem.liveWorkCondition}
                onChange={(e) => this.handleValueChange(this.getFormFields().liveWorkCondition, e)}
            />
        )
    }
    politicalSituation() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.residentailForeignTravelFormTitle.politicalSituation}
                value={this.state.residentialData.politicalSituation}
                placeholder={'Select political situation...'}
                options={Config.quotation.optionItem.politicCondition}
                onChange={(e) => this.handleValueChange(this.getFormFields().politicalSituation, e)}
            />
        )
    }

    render() {
        return (
            <>
                <span style={{ color: 'red', fontStyle: 'italic', fontSize: '14px' }}>All fields are required</span>

                <div className="w-100 mt-4" >
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.stayDuration()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0"></div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                            {this.residenceOrTravelAddress()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                            {this.residenceOrTravelCountry()}
                        </div>
                        {
                            this.state.residentialData.residenceOrTravelCountry === "MYS" &&
                            <>
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                    {this.residenceOrTravelState()}
                                </div>
                                <div className="col-lg-3 col-sm-12 pr-3 pl-0 ">
                                    {this.residenceOrTravelPostcode()}
                                </div>
                                <div className="col-lg-3 col-sm-12 pr-3 pl-0 ">
                                    {this.residenceOrTravelCity()}
                                </div>
                            </>

                        }

                    </div>
                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                        {this.travelStayDuration()}
                    </div>
                    <div className="">
                        {this.isFirstEMploymentReason()}
                    </div>

                    {this.state.residentialData.isFirstEMploymentReason === "No" &&
                        <>
                            <div className="row m-0 w-100 mt-2">
                                <div className="col-lg-12 col-sm-12 pr-3 pl-0">
                                    {this.notFisrtEmployment()}
                                </div>
                            </div>
                        </>
                    }
                    <div className="mt-3">
                        {this.isStayThroughout()}
                    </div>
                    {this.state.residentialData.isStayThroughout === "No" &&
                        <>
                            <div className="row m-0 w-100 mt-2">
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    {this.notStayThroughoutAddress()}
                                </div>
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    {this.notStayThroughoutCountry()}
                                </div>
                                {
                                    this.state.residentialData.notStayThroughoutCountry === "MYS" &&
                                    <>
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                            {this.notStayThroughoutState()}
                                        </div>
                                        <div className="col-lg-3 col-sm-12 pr-3 pl-0">
                                            {this.notStayThroughoutCity()}
                                        </div>
                                        <div className="col-lg-3 col-sm-12 pr-3 pl-0">
                                            {this.notStayThroughoutPostcode()}
                                        </div>
                                    </>
                                }
                            </div>
                        </>
                    }
                    <div className="row m-0 w-100 mt-2 align-items-end">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.typeOfStay()}
                        </div>
                        {
                            this.state.residentialData.typeOfStay === "Other accommodation?" &&
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.otherAccommodationType()}
                            </div>
                        }
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.acommodationLocated()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.liveWorkCondition()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.politicalSituation()}
                        </div>

                    </div>

                </div >
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(ResidentialForeignTravelQuestionaire));
